// extracted by mini-css-extract-plugin
export default {"ShareContent":"ShareContent-module-d77d205b77b7ff04975a"};